import { NavLink } from 'react-router-dom';
import { AlertTriangle, BarChart3, Building2, FileSearch, FileWarning, Home, Package, PackageCheck, Settings, Upload, Users } from 'lucide-react';

const items = [
  { to: '/', label: 'Início', icon: Home, end: true },
  { to: '/emitentes', label: 'Empresas', icon: Building2, end: false },
  { to: '/pessoas', label: 'Pessoas', icon: Users, end: false },
  { to: '/produtos', label: 'Produtos', icon: Package, end: false },
  { to: '/pendencias', label: 'Pendências', icon: AlertTriangle, end: false },
  { to: '/relatorios', label: 'Relatórios', icon: BarChart3, end: false },
  { to: '/dfe', label: 'DF-e', icon: FileSearch, end: false },
  { to: '/compras', label: 'Compras', icon: PackageCheck, end: false },
  { to: '/importacoes/xml', label: 'Importação XML', icon: Upload, end: false },
  { to: '/inutilizacoes', label: 'Inutilizações', icon: FileWarning, end: false },
  { to: '/configuracoes', label: 'Configurações', icon: Settings, end: false }
];

export default function SideNav() {
  return (
    <aside className="hidden w-56 shrink-0 border-r border-slate-200 bg-white/60 md:block dark:border-slate-800/80 dark:bg-slate-950/30">
      <nav className="sticky top-14 space-y-1 p-3">
        <div className="eyebrow px-3 pb-3 pt-2">Navegação</div>
        {items.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `group flex items-center gap-3 rounded-xl border px-3 py-2.5 text-sm transition-colors ${
                isActive
                  ? 'border-emerald-500/25 bg-emerald-50 text-emerald-800 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300'
                  : 'border-transparent text-slate-600 hover:bg-slate-100 hover:text-slate-950 dark:text-slate-400 dark:hover:bg-slate-800/60 dark:hover:text-slate-100'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon className={`h-4 w-4 ${isActive ? 'text-emerald-700 dark:text-emerald-400' : 'text-slate-500 group-hover:text-slate-950 dark:group-hover:text-slate-100'}`} />
                <span className="font-medium">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
